module.exports = __webpack_public_path__ + "img/logo5.8df11dba.png";